import React from 'react';
import { Button } from 'antd';
import './index.scss';
import { FOOTER_TEXT } from '../../../../constants';
import { fetchTrendVisualizations } from '../../../../utils/fetchTrendData';

// Closes out the participant tables: what the current pairing adds up to, and
// the two ways out of it. Nothing here is live until Apply — the analysis below
// keeps running on the last applied pairing, which is what the warning says.
const TrendFooter = (props) => {
    // Promote the pairing on screen to the one the results are built from, then
    // re-run the visualizations against it — that second half is what actually
    // moves the analysis onto the new pairing. The pairing is read from props
    // rather than from `applied` afterwards, since a dispatch doesn't update
    // these props until the next render.
    const handleApply = () => {
        props.onApply();
        fetchTrendVisualizations(props, {
            matchMode: props.matchMode,
            baselineOverrides: props.baselineOverrides,
        });
    };

    return (
        <div className='trend-footer'>
            {props.isDirty ? (
                <span className='trend-footer__unsaved'>{FOOTER_TEXT.unsaved}</span>
            ) : (
                <span className='trend-footer__summary'>
                    <strong>{props.comparedCount}</strong> of {props.totalCount} {FOOTER_TEXT.willCompare}
                </span>
            )}

            <div className='trend-footer__actions'>
                <Button
                    type='text'
                    className='trend-footer__discard'
                    disabled={!props.isDirty}
                    onClick={props.onDiscard}
                >
                    {FOOTER_TEXT.discard}
                </Button>
                <Button
                    type='primary'
                    className='trend-footer__apply'
                    disabled={!props.isDirty}
                    onClick={handleApply}
                >
                    {FOOTER_TEXT.apply}
                </Button>
            </div>
        </div>
    );
};

export default TrendFooter;
